import { resolveTaskStatus } from '../helpers';
import { computeEscrowAmounts } from './escrowMetrics';

const sumAmount = (tasks) =>
    tasks.reduce((sum, task) => sum + (Number(task?.amount) || 0), 0);

/** Company-owner dashboard aggregates from company task list. */
export function computeCompanyDashboardMetrics(companyTasks = [], employees = []) {
    const tasks = companyTasks;
    let activeTasks = 0;
    let pendingTasks = 0;
    let completedTasks = 0;
    let disputedTasks = 0;
    let refundRequestedTasks = 0;
    let refundedTasks = 0;
    tasks.forEach((task) => {
        const status = resolveTaskStatus(task);
        const paymentStatus = String(task.payment?.status || '').toLowerCase();

        if (status === 'disputed') {
            disputedTasks += 1;
        } else if (status === 'refunded') {
            refundedTasks += 1;
        } else if (status === 'refund_requested') {
            refundRequestedTasks += 1;
        } else if (
            status === 'released' ||
            status === 'approved' ||
            paymentStatus === 'released'
        ) {
            completedTasks += 1;
        } else if (status === 'submitted') {
            pendingTasks += 1;
        } else if (status === 'active' || status === 'pending') {
            activeTasks += 1;
        }
    });

    const { locked, released, refunded } = computeEscrowAmounts(tasks);

    const activeEmployees = employees.filter(
        (e) => String(e?.status || 'active').toLowerCase() === 'active',
    ).length;

    const escrowTotal = locked + released + refunded || 1;

    return {
        activeTasks,
        pendingTasks,
        completedTasks,
        disputedTasks,
        refundRequestedTasks,
        refundedTasks,
        totalTasks: tasks.length,
        activeEmployees,
        escrow: { locked, released, refunded, total: escrowTotal },
        pendingReview: tasks.filter((t) => resolveTaskStatus(t) === 'submitted').length,
    };
}

/** Employee dashboard aggregates from assigned tasks + shared stats. */
export function computeEmployeeDashboardMetrics(employeeTasks = [], stats = {}) {
    const tasks = employeeTasks;
    let activeTasks = 0;
    let pendingTasks = 0;
    let completedTasks = 0;
    let disputedTasks = 0;

    tasks.forEach((task) => {
        const status = resolveTaskStatus(task);
        const paymentStatus = String(task?.payment?.status || '').toLowerCase();
        if (status === 'disputed') disputedTasks += 1;
        else if (
            status === 'released' ||
            status === 'approved' ||
            paymentStatus === 'released'
        ) {
            completedTasks += 1;
        } else if (status === 'submitted') pendingTasks += 1;
        else if (status === 'active' || status === 'pending') activeTasks += 1;
    });

    return {
        activeTasks,
        pendingTasks,
        completedTasks,
        disputedTasks,
        assignedCount: tasks.length,
        totalLocked: stats.totalLocked ?? 0,
        totalEarned: stats.totalEarned ?? 0,
        awaitingRelease: stats.awaitingRelease ?? 0,
        openDisputes: stats.openDisputes ?? 0,
        inProgressAmount: sumAmount(
            tasks.filter((t) => {
                const s = resolveTaskStatus(t);
                return s === 'active' || s === 'pending' || s === 'submitted';
            }),
        ),
    };
}
